import { useQuery } from "@tanstack/react-query";
import { useMetricsStats, useMetricsTrends } from "../../../../../shared/hooks";
import type {
  MetricsStatsParams,
  MetricsTrendsParams,
} from "../../../../../shared/api/types";
import { jeopardyApi } from "../api/jeopardy";
import type { AtRiskUsersParams } from "../api/types";
import { qk } from "../../../../../lib/queryKeys";

export const useJeopardyInsightsStats = (params?: MetricsStatsParams) => {
  return useMetricsStats({
    ...params,
    metrics: params?.metrics || [
      "high_risk_employees",
      "medium_risk_employees",
      "low_risk_employees",
      "total_active_employees",
      "wellness_participation_rate",
      "recovery_score",
      "recovery",
      "hrv",
      "average_hrv",
      "resting_heart_rate",
      "sleep_performance",
      "sleep",
      "strain",
    ],
  });
};

export const useJeopardyInsightsTrends = (params?: MetricsTrendsParams) => {
  return useMetricsTrends({
    ...params,
    metrics: params?.metrics || [
      "high_risk_employees",
      "medium_risk_employees",
      "low_risk_employees",
    ],
    granularity: params?.granularity || "daily",
  });
};

export const useAtRiskUsers = (params?: AtRiskUsersParams) => {
  return useQuery({
    queryKey: qk.jeopardy.atRiskUsers(params),
    queryFn: () => jeopardyApi.getAtRiskUsers(params),
    staleTime: 2 * 60 * 1000,
  });
};
